/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useCallback, useRef } from 'react';
import { DropdownProps } from 'types/components/Dropdown';
import { WatchTvSection } from 'types/components/WatchTv';
import useOutsideAlerter from 'hooks/useOutsideAlerter';
import DropdownCalendar from './DropdownCalendar';
import DropdownButtons from './DropdownButtons';

function Dropdown({
  setIsShowing,
  isShowing,
  buttons,
  section,
  selectedDay,
  setSelectedDay,
}: DropdownProps): JSX.Element | null {
  const closeDropdown = useCallback(() => {
    return setIsShowing(false);
  }, [setIsShowing]);

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, closeDropdown);

  return isShowing ? (
    <div className="dropdown" ref={wrapperRef} id="Dropdown">
      <div className="dropdown-container">
        {section === WatchTvSection.TV_GUIDE && (
          <DropdownCalendar closeDropdown={closeDropdown} setSelectedDay={setSelectedDay} selectedDay={selectedDay} />
        )}
        <DropdownButtons buttons={buttons} closeDropdown={closeDropdown} section={section} />
      </div>
    </div>
  ) : null;
}

export default React.memo(Dropdown);
